import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { setupElementUI } from './plugins/element';
import 'element-ui/lib/theme-chalk/display.css';
import BuryingPoint from './common/BuryingPoint/index.js'
import VueI18n from 'vue-i18n'
import axios from 'axios';
import langKey from './utils/langKey';
import VueLuckyCanvas from '@lucky-canvas/vue'
import cybImg from '@/components/cybImg.vue'
import none from '@/components/none.vue'
import QueryString from "qs"
import VueMask from 'v-mask'
// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueClipboard from 'vue-clipboard2';
// import style
import 'swiper/swiper-bundle.css';
import VueLazyload from "vue-lazyload";
import "./assets/fonts/iconfont.css";
import "./assets/fonts/fonts.css";
import "./assets/css/css.css";
import "./assets/css/common.less";
import localeJa from 'element-ui/lib/locale/lang/ja'
import localeEn from 'element-ui/lib/locale/lang/en'
import localeCn from 'element-ui/lib/locale/lang/zh-CN'
import '@/utils/setVh.js';
// loading
import $loading from '@/components/loading/loading.js'
import LazyYoutube from "vue-lazytube";
// import javascript
import mine from '@/common/common.js';
import helper from '@/common/helper.js';
import updateLangAndSystem from '@/common/updateLangAndSystem.js';
import { socketClient } from "./utils/socket";
import VueAnimateNumber from 'vue-animate-number'
import db from '@/Db'
import { runWhenIdle } from "@/utils/idle";
import { initAnalyticsOnce, track as trackEvent } from "@/utils/analytics";

Vue.component("cybImg", cybImg)
Vue.component("none", none)
axios.defaults.baseURL = helper.getApiUrl();
Vue.prototype.$EventBus = new Vue();
Vue.prototype.$https = axios;
Vue.prototype.$langKey = langKey;
Vue.prototype.$helper = helper;
Vue.prototype.$buryingPoint = new BuryingPoint()
// socket 初始化在登录后才会真正连接；避免首屏就创建复杂对象占用主线程
Vue.prototype.$ws = new socketClient();
Vue.prototype.$track = (eventName, props) => trackEvent(eventName, props);
Vue.mixin(mine);
Vue.use(VueI18n);
Vue.use(VueAwesomeSwiper);
Vue.use(VueClipboard);
// Vue.use(request);
Vue.use(VueAnimateNumber);
Vue.use(VueLuckyCanvas)
Vue.use($loading)
Vue.use(VueMask)
Vue.config.productionTip = false
Vue.use(VueLazyload, {
    // 避免首屏预拉取过多图片抢占带宽，降低 LCP 抖动
    preload: 0,
    // 避免把大图打进首屏 JS
    error: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='90'%3E%3Crect width='100%25' height='100%25' fill='%23152030'/%3E%3C/svg%3E",
    attempt: 5, // 图片加载失败后重试次数，默认3
})
Vue.use(LazyYoutube);
const query1 = QueryString.parse(location.hash.split("?")[1])
const query2 = QueryString.parse(location.search.split("?")[1])
const query = {...query1,...query2 }

helper.set('share_code', query.share_code || "");
if(query.shareBetCode) helper.set('shareBetCode', query.shareBetCode);
if(query.isSavePath && !helper.get('userInfo')) {
    helper.set('loginCallBackPath', location.pathname + location.search);
}

// 自动存入登录 token（从 URL 参数传入）
if (query.token && query.token_key) {
    helper.set("tokenInfo", {
        token: query.token,
        token_key: query.token_key
    });
}

if (query.telegramApp !== undefined) {
    helper.set('telegramApp', query.telegramApp);
}

if (query.tgWebAppStartParam !== undefined) {
    helper.set('tgWebAppStartParam', query.tgWebAppStartParam);
}
const tgWebAppStartParam = helper.get('tgWebAppStartParam');
if (tgWebAppStartParam) {
    helper.set('telegramApp', 1);
    const startParam = String(tgWebAppStartParam);
    if (startParam.startsWith('af_')) {
        helper.set('share_code', startParam.substring(3));
    }
    // 其他功能 ...
}
const telegramApp = helper.get('telegramApp');
if (telegramApp == 1) {
    // 首屏后再加载，避免与 LCP 图竞争带宽
    runWhenIdle(() => {
        helper.loadScript('https://telegram.org/js/telegram-web-app.js').then(() => {
            window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.init();
        })
        .catch(() => {});
    }, 1500);
}




(async () => {

    const ElementUILocale = {
        JPN: localeJa,
        CN: localeCn
    };
    var i18n_messages = helper.get('i18n_messages');
    var i18n_lang = helper.getLang();
    // 首屏必须有默认语言，否则 request 拦截器会携带空 lang，导致菜单/轮播等接口返回异常（表现为“刷新才出现”）
    if (!i18n_lang) {
        i18n_lang = 'CN';
        helper.setLang(i18n_lang);
    }
    setupElementUI(ElementUILocale[i18n_lang] || localeEn);
    const i18n = new VueI18n({
        locale: i18n_lang ? i18n_lang : 'CN', // 设置语言环境
        fallbackLocale: i18n_lang ? i18n_lang : 'CN', // 设置语言环境
        silentTranslationWarn: true,
        messages: i18n_messages || {}// 设置语言环境信息（缺失时先渲染首屏，后续再补齐）
    });

    // 先挂载，尽早完成首屏渲染（LCP 关键）
    new Vue({ router, store, i18n, render: h => h(App) }).$mount('#app')
    // 与 mixin/App 的 resize 一致，保证首屏 windowWidth 与布局断点一致（避免顶栏等依赖宽度的展示异常）
    store.commit('setWindowWidth')

    // 左侧菜单：先拉一次（有本地缓存时可立刻有数据）
    store.dispatch("menuList/getData").catch(() => null)

    // 系统配置/语言包：成功后必须再拉一次菜单（lang/rule 与首次请求可能不一致）
    // 注意：updateLangAndSystem 内任一行抛错会导致整段 helper 未写入，此前表现为“必须刷新才正常”
    updateLangAndSystem({ i18n })
        .then(() => store.dispatch("menuList/getData"))
        .catch(() => null)

    // 首屏后/空闲时再做初始化，减少主线程阻塞与网络竞争
    runWhenIdle(() => {
        initAnalyticsOnce("ea9ab253f12b0593c109ed4a8a1081d6", {
            debug: false,
            autocapture: false,
            track_pageview: true,
            persistence: "localStorage",
        });
    });

    // GA：空闲期再初始化，避免占用首屏关键路径
    runWhenIdle(async () => {
        const id = process.env.VUE_APP_GOOGLE_GA_ID;
        if (!id) return;
        try {
            const mod = await import(/* webpackChunkName: "analytics-gtag" */ 'vue-gtag');
            const VueGtag = mod && (mod.default || mod);
            if (!VueGtag) return;
            Vue.use(VueGtag, { config: { id } }, router);
        } catch (e) { void e; }
    }, 1600);

    runWhenIdle(() => {
        db.open().catch(() => null);
    });

    // updateLangAndSystem 已在上面立刻触发；此处不再重复调度，避免重复请求
})()